interface State{
    checklist: Array<boolean>;
    progress: number;
}

export const onboarding = {
    namespaced: true,
    state: {
        checklist: [
            false, false, false, false, false, false, false, false, false, false, false, false, false
        ],
        progress: 0,
    },

    getters: {
        setChecklist(state: State): Array<boolean> {
            return state.checklist;
        },

        setProgress(state: State): number {
            return state.progress;
        }
    },

    mutations: {
        SET_CHECKLIST(state: State, index: number): void {
            state.checklist[index] = true;
        },

        SET_PROGRESS(state: State): void {
            const maxOnboardingSteps = state.checklist.length;
            const isDoneCount = state.checklist.filter(Boolean).length;
            state.progress = Math.ceil((isDoneCount / maxOnboardingSteps) * 100);
        }
    },

    actions: {
        checklistTrue({commit}, index: number): void {
            commit('SET_CHECKLIST', index);
        },

        progressCount({commit}): void {
            commit('SET_PROGRESS');
        }
    }
}